@if (isWorkflowDetailsLoading()) {
  <lib-overlay-loader />
} @else {
  @if (!isEmbedded()) {
    <lib-request-details-header
      [requestDetailsResponse]="workflowDetails()"
      [showRequestId]="showID()"
      [showTrigger]="false"
      [showCategory]="showCategory()"
      [showDescription]="showDescription()"
      [showStatus]="false"
      [disableExpand]="disableExpand()"
      (discardChanges)="openDiscardModal()" />

    <div class="py-lg border-b border-neutral-200 mb-2xl">
      <h5 class="text-lg font-semibold text-neutral-900">
        {{ 'workflow_configurations_details_screen_sub_title' | transloco }}
      </h5>
    </div>
  }

  @if (isWorkflowStepsLoading()) {
    <div class="flex justify-center items-center mt-2xl">
      <lib-loader />
    </div>
  } @else {
    @for (step of workFlowStepsList(); track step.id; let i = $index) {
      @if (step.mode === 'view') {
        <lib-workflow-step-info-view
          [stepInfo]="step"
          [disableExpand]="disableExpand()"
          (switchToEditMode)="switchStepIntoEditMode($event)"
          (discardChanges)="openDiscardModal()" />
      } @else {
        <form [formGroup]="stepInfoForm()">
          <lib-workflow-step-info-form
            [stepInfo]="step"
            [stepIndex]="i"
            [flowTemplateId]="workflowId()"
            [isFormChanged]="isFormChanged()"
            [stepInfoForm]="stepInfoForm()"
            [assigneeSelectDependency]="assigneeSelectDependency()"
            [resourceSelectDependency]="resourceSelectDependency()"
            [isUpdateStepLoading]="isUpdateStepLoading()"
            [disableExpand]="disableExpand()"
            [assigneeReferenceArray]="assigneeReferenceArray()"
            [currentStep]="selectedStep()"
            (addFromGroupEmitter)="addNewFormGroup($event)"
            (deleteFromGroupIndexEmitter)="deleteFormGroup($event)"
            (discardChanges)="openDiscardModal()"
            [canBeSentBackToFirstPosition]="canBeSentBackToFirstPosition()"
            [hasStepActions]="workflowDetails().data.has_step_actions ?? true"
            (submitForm)="submitForm($event)" />
        </form>
      }
    }
  }
}

<ng-template #discard>
  <div class="flex justify-center mb-xl">
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      class="size-12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#FEF2F2" />
      <path
        d="M24 21V26"
        stroke="#EF4444"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M23.9994 33.4112H17.9394C14.4694 33.4112 13.0194 30.9312 14.6994 27.9012L17.8194 22.2812L20.7594 17.0013C22.5394 13.7912 25.4594 13.7912 27.2394 17.0013L30.1794 22.2913L33.2994 27.9113C34.9794 30.9413 33.5194 33.4212 30.0594 33.4212H23.9994V33.4112Z"
        stroke="#EF4444"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M23.9961 29H24.0051"
        stroke="#EF4444"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </div>

  <div class="text-center font-medium text-lg text-neutral-900 mb-sm">
    {{ 'discard_modal_title' | transloco }}
  </div>

  <div class="text-center text-sm text-neutral-500">
    {{ 'discard_modal_description' | transloco }}
  </div>

  <div class="flex flex-col justify-end gap-md mt-4xl">
    <button
      id="discard_modal_save_button"
      class="px-2xl py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none cursor-pointer"
      (click)="submitForm(this.selectedStep())">
      {{ 'discard_modal_save_button' | transloco }}
    </button>

    <button
      id="discard_modal_discard_button"
      class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium border border-neutral-300 cursor-pointer"
      (click)="discardForm()">
      {{ 'discard_modal_discard_button' | transloco }}
    </button>
  </div>
</ng-template>
